var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortByAlphaBlackAtoz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sort_by_alpha_black_18dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.918,
    height: 12.918,
    viewBox: "0 0 12.918 12.918",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_33865",
    "data-name": "Path 33865",
    d: "M0,0H12.918V12.918H0ZM0,0H12.918V12.918H0ZM.4.4H12.515V12.515H.4Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33866",
    "data-name": "Path 33866",
    d: "M8.78,3.57H6.24L7.51,2.3ZM6.256,11.488H8.764L7.51,12.742ZM4.022,4.437,1.6,10.605h.99l.5-1.319H5.836l.5,1.319h.99L4.9,4.437ZM3.414,8.4,4.458,5.616,5.5,8.4ZM9.206,9.75H12.5v.856H7.908V9.911L11.095,5.3H7.93V4.442H12.4V5.12L9.206,9.75Z",
    transform: "translate(-0.739 -1.062)",
    fill: "#55555a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortByAlphaBlackAtoz);
export default __webpack_public_path__ + "static/media/sort_by_alpha_black_atoz.b9ca6a247bf9b31e850a32c51de15bb9.svg";
export { ForwardRef as ReactComponent };